// @ts-nocheck
import CryptoJS from 'crypto-js';
import MD5 from 'js-md5';
import Base64 from 'crypto-js/enc-base64';
export default {
  // 加密
  encrypt(word, keyStr) {
    // word-加密的字段名字  keyStr-key值（16位）
    if (Object.prototype.toString.call(word) === '[object Object]') {
      word = JSON.stringify(word);
    }
    keyStr = keyStr || 'abcdefgabcdefg12';
    const key = CryptoJS.enc.Utf8.parse(keyStr); // Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    const srcs = CryptoJS.enc.Utf8.parse(word);
    const encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  },
  // 解密
  decrypt(word, keyStr) {
    keyStr = keyStr || 'abcdefgabcdefg12';
    const key = CryptoJS.enc.Utf8.parse(keyStr);
    const decrypt = CryptoJS.AES.decrypt(word, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  },
  getMd5: (str) => MD5(str).toString(),
  base64Encode: (val) => {
    const encodedWord = CryptoJS.enc.Utf8.parse(val); // encodedWord Array object
    const encoded = CryptoJS.enc.Base64.stringify(encodedWord); // string: 'NzUzMjI1NDE='
    return encoded;
  }
};
